import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';
import { LocationState, Location, LocationPlace } from './ubications.interface';

// Thunks para Usuarios
import * as thunks from './ubicationsThunks';
import { APIResponse } from '@/types/custom-http';



const initialState: LocationState = {
  locations: [],
  selectedLocation: null,
  ubications: [],
  selectedUbication: null,
  loading: false,
  error: null,
};



// Slice
const ubicationsSlice = createSlice({
  name: 'ubications',
  initialState,
  reducers: {
    clearLocations: (state) => {
      state.locations = [];
    },
    clearSelectedLocation: (state) => {
      state.selectedLocation = null;
    },
    clearUbications: (state) => {
      state.ubications = [];
    },
    clearSelectedUbication: (state) => {
      state.selectedUbication = null;
    },
    clearLocationError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Obtener todos los almacenes
      .addCase(thunks.fetchLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchLocations.fulfilled, (state, action: PayloadAction<APIResponse<Location[]>>) => {
        state.loading = false;
        if(action.payload.data){
          state.locations = action.payload.data;
        }
      })
      .addCase(thunks.fetchLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Obtener un Almacén específico por ID
      .addCase(thunks.fetchLocationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchLocationById.fulfilled, (state, action: PayloadAction<APIResponse<Location>>) => {
        state.loading = false;
        if(action.payload.data){
          state.selectedLocation = action.payload.data;
        }
      })
      .addCase(thunks.fetchLocationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Crear un nuevo Almacén
      .addCase(thunks.createLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.createLocation.fulfilled, (state, action: PayloadAction<APIResponse<Location>>) => {
        state.loading = false;
        if(action.payload.data){
          state.locations.push(action.payload.data);
        }
      })
      .addCase(thunks.createLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Actualizar datos de un Almacén
      .addCase(thunks.updateLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.updateLocation.fulfilled, (state, action: PayloadAction<APIResponse<Location>>) => {
        state.loading = false;
        const index = state.locations.findIndex(location => location.id === action.payload.data?.id);
        if (index !== -1 && action.payload.data) {
          state.locations[index] = action.payload.data;
        }
        if (state.selectedLocation && state.selectedLocation.id === action.payload.data?.id) {
          state.selectedLocation = action.payload.data;
        }
      })
      .addCase(thunks.updateLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Eliminar un Almacén
      .addCase(thunks.deleteLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.deleteLocation.fulfilled, (state, action) => {
        state.loading = false;
        const deletedLocationId = action.payload;
        
        state.locations = state.locations.filter(location => location.id !== deletedLocationId);
        
        if (state.selectedLocation && state.selectedLocation.id === deletedLocationId) {
          state.selectedLocation = null;
        }
      })
      .addCase(thunks.deleteLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })


      // Obtener todas las ubicaciones físicas
      .addCase(thunks.fetchLocationsPlaces.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchLocationsPlaces.fulfilled, (state, action: PayloadAction<APIResponse<LocationPlace[]>>) => {
        state.loading = false;
        if(action.payload.data){
          state.ubications = action.payload.data;
        }
      })
      .addCase(thunks.fetchLocationsPlaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Obtener una Ubicación Física específica por ID
      .addCase(thunks.fetchLocationPlaceById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchLocationPlaceById.fulfilled, (state, action: PayloadAction<APIResponse<LocationPlace>>) => {
        state.loading = false;
        if(action.payload.data){
          state.selectedUbication = action.payload.data;
        }
      })
      .addCase(thunks.fetchLocationPlaceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Crear una nueva Ubicación Física
      .addCase(thunks.createLocationPlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.createLocationPlace.fulfilled, (state, action: PayloadAction<APIResponse<LocationPlace>>) => {
        state.loading = false;
        if(action.payload.data){
          state.ubications.push(action.payload.data);
        }
      })
      .addCase(thunks.createLocationPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Actualizar datos de una Ubicación Física
      .addCase(thunks.updateLocationPlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.updateLocationPlace.fulfilled, (state, action: PayloadAction<APIResponse<LocationPlace>>) => {
        state.loading = false;
        const index = state.ubications.findIndex(location => location.id === action.payload.data?.id);
        if (index !== -1 && action.payload.data) {
          state.ubications[index] = action.payload.data;
        }
        if (state.selectedUbication && state.selectedUbication.id === action.payload.data?.id) {
          state.selectedUbication = action.payload.data;
        }
      })
      .addCase(thunks.updateLocationPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Eliminar una Ubicación Física
      .addCase(thunks.deleteLocationPlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.deleteLocationPlace.fulfilled, (state, action) => {
        state.loading = false;
        const deletedUbicationId = action.payload;
        
        state.ubications = state.ubications.filter(elem => elem.id !== deletedUbicationId);
        
        if (state.selectedUbication && state.selectedUbication.id === deletedUbicationId) {
          state.selectedUbication = null;
        }
      })
      .addCase(thunks.deleteLocationPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })
      
  },
});

// Selectors
export const selectAllLocations = (state: RootState) => state.ubications.locations;
export const selectLocationById = (state: RootState, id: number) => state.ubications.locations.find(location => location.id === id);
export const selectSelectedLocation = (state: RootState) => state.ubications.selectedLocation;

export const selectAllUbications = (state: RootState) => state.ubications.ubications;
export const selectUbicationById = (state: RootState, id: number) => state.ubications.ubications.find(elem => elem.id === id);
export const selectSelectedUbication = (state: RootState) => state.ubications.selectedUbication;


export const selectLocationLoading = (state: RootState) => state.ubications.loading;
export const selectLocationError = (state: RootState) => state.ubications.error;

// Actions
export const { clearLocations, clearUbications, clearSelectedLocation, clearSelectedUbication,  clearLocationError} = ubicationsSlice.actions;

export default ubicationsSlice.reducer;
